import React, { useEffect, useRef, useState } from 'react';

function TimeLeft(props) {
  const { countTime, resend, currentTimer, setShowResend } = props;
  const [timeLeft, setTimeLeft] = useState(countTime);
  let timerId = useRef();
  useEffect(() => {
    setTimeLeft(() => countTime);
    clearInterval(timerId.current);
    timerId.current = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);
  }, [resend]);
  useEffect(() => {
    if (timeLeft == 0) {
      setShowResend(true);
      clearInterval(timerId.current);
      currentTimer.current = timeLeft;
    }
  }, [timeLeft]);

  return (
    <span>
      <div>00: {timeLeft < 10 ? `0${timeLeft}` : timeLeft}</div>
    </span>
  );
}

export default TimeLeft;
